import { useEffect, useState } from "react";

export type UseDisclosureProps = {
  isOpen?: boolean;
  isDefaultOpen?: boolean;
  onOpen?(): void;
  onClose?(): void;
};

export function useDisclosure(props: UseDisclosureProps = {}) {
  const { isOpen: isOpenProp, isDefaultOpen, onOpen, onClose } = props;

  const [isOpen, setIsOpen] = useState(isDefaultOpen || false);

  useEffect(() => {
    isOpenProp !== isOpen && setIsOpen(!!isOpenProp);
  }, [isOpenProp]);

  const open = (e?: any) => {
    if (e && e["stopPropagation"]) {
      // if e is a mouse event and has stopPropagation, call it.
      e.stopPropagation();
    }
    setIsOpen(true);
    onOpen && onOpen();
  };

  const close = (e?: any) => {
    if (e && e["stopPropagation"]) {
      // if e is a mouse event and has stopPropagation, call it.
      e.stopPropagation();
    }
    setIsOpen(false);
    onClose && onClose();
  };

  const toggle = (e?: any) => {
    if (isOpen) {
      close(e);
    } else {
      open(e);
    }
  };

  return { isOpen, open, close, toggle };
}

export type UseDisclosureReturn = ReturnType<typeof useDisclosure>;
